import React from 'react'
import PropTypes from 'prop-types'
import itemHelper from '../../utils/itemHelper'

const { getItemData } = itemHelper

const ItemCard = (props) => {
    const { item: itemBase, clickEquip, clickUnequip } = props

    const item = getItemData(itemBase)

    const handlerButton = (label, className, handler) => (
        <button type="button" className={className} onClick={handler}>
            {label}
        </button>
    )

    const clickEquipHandler = (clickEquip.enabled)
        ? handlerButton('➕ EQUIP', 'button--add', () => clickEquip.handler([item.ID]))
        : ''
    const clickUnequipHandler = (clickUnequip.enabled)
        ? handlerButton('➖ REMOVE', 'button--delete', () => clickUnequip.handler([item.ID]))
        : ''

    return (
        <div key={item.ID} className={`item__card item__card--${item.type}`}>
            <span>
                {item.icon}
            </span>
            {item.name}
            {clickEquipHandler}
            {clickUnequipHandler}
        </div>
    )
}

ItemCard.propTypes = {
    item: PropTypes.object.isRequired,
    clickEquip: PropTypes.object.isRequired,
    clickUnequip: PropTypes.object.isRequired,
}

export default ItemCard
